import { SITE, STATS } from "../data/content";
import { Reveal } from "./Reveal";

const HERO_BG =
  "https://static.prod-images.emergentagent.com/jobs/6993066b-ff7c-42b2-b892-e8aa9d739ad3/images/00483a6508fcd721e9cf796ebdfdd273545519092b165690a549b4047bccce2f.png";

export const Hero = () => {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative overflow-hidden pt-32 lg:pt-40 pb-24 lg:pb-32 bg-white"
    >
      {/* Background image, contained right side */}
      <div className="absolute inset-y-0 right-0 w-full lg:w-[55%] pointer-events-none">
        <div
          className="absolute inset-0 bg-cover bg-center opacity-90"
          style={{ backgroundImage: `url(${HERO_BG})` }}
          aria-hidden
        />
        <div className="absolute inset-0 bg-gradient-to-r from-white via-white/85 lg:from-white/95 lg:via-white/30 to-transparent" />
      </div>

      <div className="relative max-w-[1400px] mx-auto px-6 lg:px-10">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-end">
          <Reveal className="lg:col-span-8">
            <div className="flex items-center gap-4 mb-8">
              <span className="h-px w-12 bg-[#0A192F]/40" />
              <span className="text-xs uppercase tracking-[0.3em] text-[#0A192F]/60 font-medium">
                Office of Sean Bledsoe
              </span>
            </div>

            <h1
              data-testid="hero-headline"
              className="font-serif text-[44px] sm:text-6xl lg:text-[88px] leading-[0.95] tracking-tight text-[#0A192F]"
            >
              Re-shaping the
              <br />
              culture of <em className="italic font-normal">prevention,</em>
              <br />
              one patient at a time.
            </h1>

            <p className="mt-10 max-w-2xl text-lg text-[#475569] leading-relaxed">
              {SITE.shortBio}
            </p>

            <div className="mt-12 flex flex-wrap gap-4">
              <a
                href="#contact"
                data-testid="hero-cta-primary"
                className="inline-flex items-center gap-3 px-7 py-4 bg-[#0A192F] text-white text-sm tracking-wide rounded-full hover:-translate-y-0.5 hover:shadow-2xl transition-all duration-300"
              >
                Schedule a private briefing
                <span aria-hidden>→</span>
              </a>
              <a
                href="#ventures"
                data-testid="hero-cta-secondary"
                className="inline-flex items-center gap-3 px-7 py-4 border border-[#0A192F] text-[#0A192F] text-sm tracking-wide rounded-full hover:bg-[#0A192F] hover:text-white transition-all duration-300"
              >
                Explore the portfolio
              </a>
            </div>
          </Reveal>

          <Reveal delay={180} className="lg:col-span-4">
            <div className="border-l-2 border-[#0A192F]/15 pl-6">
              <div className="text-xs uppercase tracking-[0.3em] text-[#0A192F]/60 mb-6">
                In numbers
              </div>
              <dl className="grid grid-cols-2 gap-6">
                {STATS.map((s) => (
                  <div key={s.label} data-testid={`hero-stat-${s.label.toLowerCase().replace(/ /g, "-")}`}>
                    <dt className="text-xs uppercase tracking-widest text-[#475569]">
                      {s.label}
                    </dt>
                    <dd className="mt-2 font-serif text-3xl lg:text-4xl text-[#0A192F] ticker">
                      {s.value}
                      <span className="text-[#475569] text-2xl">{s.suffix}</span>
                    </dd>
                  </div>
                ))}
              </dl>
            </div>
          </Reveal>
        </div>

        <Reveal delay={320} className="mt-20 lg:mt-28 flex items-center gap-6">
          <span className="text-xs uppercase tracking-[0.3em] text-[#475569]">
            Currently in:
          </span>
          <span className="text-sm text-[#0A192F]">{SITE.location}</span>
          <span className="flex-1 h-px silver-line" />
        </Reveal>
      </div>
    </section>
  );
};
